import { withInstall } from '@bigin/utils'

import Popconfirm from './src/popconfirm.vue'

export const BPopconfirm = withInstall(Popconfirm)
export default BPopconfirm

export * from './src/popconfirm'
